import { useState, useEffect } from "react";
import TransactionList from "../financial-management/TransactionList.tsx";
import { NavLink } from "react-router-dom";
import CustomButton from "../kits/button/CustomButton.jsx";
import useAxios from "../../services/useAxios.tsx";
import ColorSchema from "../kits/Color/index";
import { ArrowLeftIcon } from "../kits/Icons";

import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function LastPayment() {
  const { execute: transactionList } = useAxios("api2/transactions_list");
  const [transact, setTransact] = useState([]);
  useEffect(() => {
    transactionList({ page: 1, count: 5 }).then(data => {
      let resTran = data.transactions.map(t => {
        let date;
        if ("" + t.mtm !== "") {
          date = new DateObject({
            date: +t.mtm * 1000,
            calendar: persian,
            locale: persian_fa
          });
        }
        const isReceiver = +t.customer_id === +t.to_account.customer_id;

        return {
          id: t.bank_transaction__id,
          uid: t.customer_id,
          payDate: date ? date.format("YYYY/MM/DD") : "",
          payTime: date ? date.format("HH:mm") : "",
          payType: +t.type,
          bankName: isReceiver ? t.to_account.bank : t.from_account.bank,
          accountNumber: isReceiver
            ? t.to_account.account_number
            : t.from_account.account_number,
          status: +t.status
        };
      });
      setTransact(resTran);
      return resTran;
    });
    console.log("transact", transact);
  }, []);
  return (
    <>
      <div className="d-flex">
        <div
          className="d-flex align-items-center ms-auto"
          style={{
            color: ColorSchema.primary_custom,
            borderBottom: `1px solid ${ColorSchema.primary_custom}`
          }}
        >
          <NavLink
            to="/financial-management"
            // target="_blank"
            className=" text-decoration-none px-1"
          >
            <p color="info">مشاهده همه</p>
          </NavLink>
          <ArrowLeftIcon
            color={`${ColorSchema.primary_custom}`}
            style={{ width: 20, height: 20 }}
          />
        </div>
      </div>
      <div className="mt-3">
        {/* {transact.map(value => { */}
        {/* return  */}
        {transact.length > 0 ? (
          <TransactionList transactions={transact}></TransactionList>
        ) : (
          <div>پرداخت جدیدی وجود ندارد</div>
        )}
        {/* })} */}
      </div>
    </>
  );
}
